import classNames from 'classnames'
import React from 'react'

import type { RadioSize } from './Radio'

import styles from './RadioIndicator.module.scss'

export interface RadioIndicatorProps {
  size?: RadioSize
  checked?: boolean
  disabled?: boolean
}

export const RadioIndicator: React.FC<RadioIndicatorProps> = ({
  size = 'md',
  checked,
  disabled,
}) => {
  return (
    <span
      className={classNames(styles.root, styles[`size-${size}`], {
        [styles.disabled]: disabled,
      })}
      aria-hidden
    >
      <span
        className={classNames(styles.box, {
          [styles.active]: checked,
        })}
      />
    </span>
  )
}
